/* unplugin-vue-components disabled */import script from "./container-baidu.vue?vue&type=script&setup=true&lang=js"
export * from "./container-baidu.vue?vue&type=script&setup=true&lang=js"

import "./container-baidu.vue?vue&type=style&index=0&id=764759f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764759f6"]])

export default __exports__